import { Search } from '@mui/icons-material';
import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 12px;

  svg {
    width: 18px;
    height: 18px;
  }

  input {
    flex: 1;
    height: 40px;
    outline: none;
    border: none;
    padding: 0 10px;
    color: ${({ theme }) => theme.colors.prussianBlue};
    background-color: ${({ theme }) => theme.colors.cultured};
    font-size: 13px;

    ::placeholder {
      font-size: 13px;
      color: ${({ theme }) => theme.colors.cflowerBlue};
      font-weight: 500;
    }
  }
`;

export const StyledSearchIcon = styled(Search)`
  color: ${({ theme }) => theme.colors.prussianBlue};
`;
